<template>
  <div
    v-if="!isLoading"
    class="container mx-auto"
  >
    <p
      v-if="introText"
      class="text-sm text-center mb-5"
      v-html="introText"
    />
    <search-input
      v-model="query"
      :searchable="searchable"
      :search-input-color="config.search_input_color"
      :css-radius="searchInputRadius"
    />
    <div
      v-if="searchable && query && query.length > 0 && rows.length == 0"
      class="text-sm"
    >
      {{ noResultsText }}
    </div>  
    <div
      v-for="item in rows"
      :key="item.metric.api"
      class="flex flex-wrap overflow-hidden mb-5"
      :style="{backgroundColor:config.bg_color}"
      :class="[cardRadius]"
    >
      <list-image
        :src="filterImage(item)"
        :classes="gridClasses(false)"
        :metric="item.metric.api"
      />
      <div 
        class="w-full overflow-hidden"
        :class="gridClasses(true)"  
      >
        <div class="p-5">
          <div class="flex flex-wrap">
            <h1
              v-if="item.title"
              class="flex-auto text-xl font-semibold"
            >
              {{ item.title }}
            </h1>
            <div
              v-if="item.teaser"
              class="w-full flex-none text-sm font-medium mt-2"
            >
              {{ item.teaser }}
            </div>
          </div>
          <p
            class="text-sm content my-4"
            v-html="item.text"
          />
          <div
            v-if="item.link1||item.link2"
            class="flex space-x-3 text-sm font-medium"
          >
            <div class="flex-auto flex space-x-3">
              <a
                v-if="item.link1"
                :target="config.primary_cta_target"
                :href="item.link1"
                class="flex items-center justify-center text-white p-3"
                :class="[buttonRadius]"
                :style="{backgroundColor:config.button_color}"
              >{{ item.link1label }}</a>
              <a
                v-if="item.link2"
                :target="config.secondary_cta_target"
                :href="item.link2"
                class="flex items-center justify-center border p-3"
                :class="[buttonRadius]"
                :style="{borderColor:config.button_color}"
              >{{ item.link2label }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p
      v-if="outroText"
      class="text-sm text-center"
      v-html="outroText"
    />
  </div>
</template>

<script>
import ApiMixin from '@/mixins/ApiMixin.vue'
import ListImage from '../directives/ListImage.vue'
import SearchInput from '../directives/SearchInput.vue'

// app.js
export default {
  components: {
    ListImage,
    SearchInput
  },
  mixins: [
    ApiMixin
  ],
  props: {...ApiMixin.props }
}
</script>

<style>
@tailwind utilities;
@tailwind base;

.content a {
  text-decoration: underline;
}
</style>